import { Box, Link, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { PerformanceGoalsEmployeeProgressFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { GoalProgressBar } from 'modules/goals/components/GoalProgressBar'

interface Props {
  progress: number
  weights?: PerformanceGoalsEmployeeProgressFragment['weights']
  needsAttention?: boolean
  showLabel?: boolean
}

export const ProgressSummary: React.FC<Props> = ({
  progress,
  weights = [],
  needsAttention = false,
  showLabel = false,
}) => {
  const [open, toggle] = useToggle()

  return (
    <Box gap="s8">
      {showLabel && (
        <Text.Normal size="200" weight="semibold">
          {i18n.t('performance_goals.progress_summary.title')}
        </Text.Normal>
      )}

      <GoalProgressBar
        progress={progress}
        needsAttention={needsAttention}
        needsAttentionTooltip={i18n.t('performance_goals.progress_summary.needs_attention_tooltip')}
      />

      {weights.length > 0 && (
        <Tooltip.ItemList attachment="top center" open={open} toggle={toggle} size="auto">
          <Link.Touchable>
            {i18n.t('performance_goals.progress_summary.view_details')}
          </Link.Touchable>

          {/* Tooltip content */}
          <Box width="s400" gap="s24" textAlign="left">
            <Text.Normal size="200" weight="medium">
              {i18n.t('performance_goals.progress_summary.progress_breakdown.title')}
            </Text.Normal>

            <Box gap="s8" flexDirection="row">
              <Box width="full">
                <Text.Normal size="100" weight="bold">
                  {i18n
                    .t('performance_goals.progress_summary.progress_breakdown.goal')
                    .toUpperCase()}
                </Text.Normal>
              </Box>
              <Box minWidth="s64">
                <Text.Normal size="100" weight="bold">
                  {i18n
                    .t('performance_goals.progress_summary.progress_breakdown.weight')
                    .toUpperCase()}
                </Text.Normal>
              </Box>
              <Box minWidth="s64">
                <Text.Normal size="100" weight="bold">
                  {i18n
                    .t('performance_goals.progress_summary.progress_breakdown.progress')
                    .toUpperCase()}
                </Text.Normal>
              </Box>
            </Box>
          </Box>

          {weights.map(({ id, weight, metricGroup }) => (
            <Box key={id} width="s400" flexDirection="row" gap="s8" textAlign="left">
              <Box width="full">
                <Text.Normal size="200" weight="semibold">
                  {metricGroup?.title}
                </Text.Normal>
              </Box>
              <Box minWidth="s64">
                <Text.Normal size="200">{i18n.formatNumber(weight)}%</Text.Normal>
              </Box>
              <Box minWidth="s64">
                <Text.Normal size="200">{metricGroup?.summary?.averageProgress}%</Text.Normal>
              </Box>
            </Box>
          ))}
        </Tooltip.ItemList>
      )}
    </Box>
  )
}
